import(/* webpackMode: "eager" */ "/var/directorder/app/main/apps/buyer/src/app/layout.js");
